/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  AffiliateResponseActiveReferrals,
  AffiliateResponseActiveReferralsFromJSON,
  AffiliateResponseActiveReferralsFromJSONTyped,
  AffiliateResponseActiveReferralsToJSON,
} from './AffiliateResponseActiveReferrals'
import { AffiliateTeam, AffiliateTeamFromJSON, AffiliateTeamFromJSONTyped, AffiliateTeamToJSON } from './AffiliateTeam'
import {
  ReferralsStatistics,
  ReferralsStatisticsFromJSON,
  ReferralsStatisticsFromJSONTyped,
  ReferralsStatisticsToJSON,
} from './ReferralsStatistics'

/**
 *
 * @export
 * @interface AffiliateResponse
 */
export interface AffiliateResponse {
  /**
   *
   * @type {AffiliateTeam}
   * @memberof AffiliateResponse
   */
  leftTeam?: AffiliateTeam
  /**
   *
   * @type {AffiliateTeam}
   * @memberof AffiliateResponse
   */
  rightTeam?: AffiliateTeam
  /**
   *
   * @type {ReferralsStatistics}
   * @memberof AffiliateResponse
   */
  directReferrals?: ReferralsStatistics
  /**
   *
   * @type {AffiliateResponseActiveReferrals}
   * @memberof AffiliateResponse
   */
  activeReferrals?: AffiliateResponseActiveReferrals
}

export function AffiliateResponseFromJSON(json: any): AffiliateResponse {
  return AffiliateResponseFromJSONTyped(json, false)
}

export function AffiliateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    leftTeam: !exists(json, 'leftTeam') ? undefined : AffiliateTeamFromJSON(json['leftTeam']),
    rightTeam: !exists(json, 'rightTeam') ? undefined : AffiliateTeamFromJSON(json['rightTeam']),
    directReferrals: !exists(json, 'directReferrals')
      ? undefined
      : ReferralsStatisticsFromJSON(json['directReferrals']),
    activeReferrals: !exists(json, 'activeReferrals')
      ? undefined
      : AffiliateResponseActiveReferralsFromJSON(json['activeReferrals']),
  }
}

export function AffiliateResponseToJSON(value?: AffiliateResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    leftTeam: AffiliateTeamToJSON(value.leftTeam),
    rightTeam: AffiliateTeamToJSON(value.rightTeam),
    directReferrals: ReferralsStatisticsToJSON(value.directReferrals),
    activeReferrals: AffiliateResponseActiveReferralsToJSON(value.activeReferrals),
  }
}
